import config from '@/config';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('user', [
      'getUserData',
    ]),
    selectedLanguage() {
      if (this.getUserData) {
        return config.LANGUAGES[this.getUserData.user.language] || navigator.language;
      }
      return navigator.language;
    },
  },
};
